import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CustomIJitsiMeetExternalApi } from '../../Jitsi/JitsiHelper';

interface JitsiMeetSliceType {
  activePanel: "chat" | "participants" | "tileView" | null;
  apiRef: CustomIJitsiMeetExternalApi | null;
  chatIndication: boolean;
  isMeetjoined: boolean;
  jitsiHostId: string | undefined;
}

const initialState: JitsiMeetSliceType = {
  activePanel: null,
  apiRef: null,
  chatIndication: false,
  isMeetjoined: false,
  jitsiHostId: undefined
};

const JitsiMeetSlice = createSlice({
  name: 'JitsiMeetSlice',
  initialState,
  reducers: {
    setActivePanel(state, action: PayloadAction<{ activePanel: "chat" | "participants" | "tileView" | null }>) {
      state.activePanel = action.payload.activePanel;
    },
    setApiRef(state, action: PayloadAction<{ apiRef: CustomIJitsiMeetExternalApi | null}>) {
      state.apiRef = action.payload.apiRef;
    },
    setChatIndication(state, action: PayloadAction<{ chatIndication: boolean}>) {
      state.chatIndication = action.payload.chatIndication;
    },
    setIsMeetJoined(state, action: PayloadAction<{ isMeetjoined: boolean}>) {
      state.isMeetjoined = action.payload.isMeetjoined;
    },
    setJitsiHostId(state, action: PayloadAction<{jitsiHostId: string | undefined}>){
      state.jitsiHostId = action.payload.jitsiHostId;
    }
  },
});

export const { setActivePanel, setApiRef,setChatIndication, setIsMeetJoined, setJitsiHostId } = JitsiMeetSlice.actions;
export default JitsiMeetSlice.reducer;
